import { ILandingPlanning } from 'partner360/models/landing/ILandingPlanning'

export const getAllPlanningOfferings = (planning: ILandingPlanning | undefined) => {
  if (!planning) {
    return []
  }
  const allOfferingsItems = planning.AllCategories.flatMap((el) => el.Offerings)
  const sorted = [...allOfferingsItems].sort((a, b) => a.OrderBy - b.OrderBy)
  return Array.from(new Set(sorted.map((el) => el.Offering)))
}
